import { useEffect } from 'react'
import { useQuery } from 'react-query'
import ability, { FEATURE_FLAGS, updateAbility } from '../../../config/ability'
import { getLocalInfo } from '../../services/userService'
import { apiGet } from '../../utils/api/generic'
import { getToken } from '../../utils/apiClient'

export default () => {
  const userData = getLocalInfo()
  const token = getToken()
  const { data: featureFlags, isLoading: isLoadingFeatureFlags } = useQuery(
    'featureFlags',
    () => apiGet<{ [key in keyof typeof FEATURE_FLAGS]: boolean }>('/feature-flags'),
    {
      enabled: !!token,
    }
  )

  useEffect(() => {
    updateAbility(ability, userData, featureFlags)
  }, [userData, featureFlags])

  return { isLoadingFeatureFlags }
}
